<template>
  <div>
    <!-- <loader /> -->
   
    <div class="container-fluid py-0 px-0  d-md-none d-block">
        <!-- my slider do not touch this code -->
        <VueSlickCarousel :arrows="false"   v-bind="homeSliderNew" class="show-on-small-devices " :style="{ paddingTop: '8px', paddingBottom: '3px' }">
          <!-- PLACEHOLDER IMAGE -->
          <div v-if="Banners.length == 0" v-for="(singleBanner, bannerKey1) in 3" :key="bannerKey1">
            <div class="slider-container mx-auto 22">
              <img src="@/assets/img/transparent_banner.png" alt class="img-fluid pt-2 cus-img object-fit-contain" />
            </div>
          </div>

          <div v-if="Banners.length > 0" v-for="(singleBanner, bannerKey) in Banners" :key="bannerKey">
            <div class="slider-container mx-auto 111 ">
              <transition name="fade px-4  image-border ">
                <div class="centered-image-container" >

                  <img v-lazy="singleBanner.banner_image_url" alt :style="{  height: '140px' }"
                    class="img-fluid cus-img banners px-4  object-fit-contain hloo" />
                </div>
              </transition>

            </div>
          </div>
        </VueSlickCarousel>
      </div>


    <!-- Sticky Section -->
    <section :class="['filter-sticky-top  pt-1 show-on-small-devices', { 'is-sticky': isSticky }]">
      <section class="container-fluid my-3">
        <div class="row tab-showing">
          <div class="col-4 px-2" v-for="(item, index) in tabArray" :key="index" @click="TabChange(item.position, item.payload)">
            <div class="h-100 category-btn d-flex align-items-center justify-content-center text-center px-3 py-2"
              :class="selectedTab.indexOf(item.position) >= 0 ? 'active' : ''">
              {{ item.title }}
            </div>
          </div>
        </div>
      </section>
      <section class="container-fluid" :class="checkFilterExist == false ? 'my-3' : ''" v-if="!checkFilterExist">
        <div class="d-flex justify-content-center align-items-center">
          <div><hr class="hr-line" /></div>
          <div class="filter-new-btn mx-2" @click="showFilterModal">
            <div>Filters</div>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sliders-h" class="svg-inline--fa fa-sliders-h fa-w-16" role="img" height="20" width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="#000" d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z" />
            </svg>
          </div>
          <div><hr class="hr-line" /></div>
        </div>
      </section>
      <section class="container-fluid" :class="checkFilterExist ? 'my-3' : ''">
        <div class="filter-tabs" v-if="checkFilterExist">
          <div class="row">
            <div class="col-1">
              <span class="mr-3 ml-2" @click="showFilterModal">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sliders-h" class="svg-inline--fa fa-sliders-h fa-w-16" role="img" height="17" width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="#000" d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z" />
                </svg>
              </span>
            </div>
            <div class="col-11">
              <ul class="list-inline filter-list mb-0">
                <span v-for="(data, index2) in showFilter" :key="index2">
                  <li class="list-inline-item active mr-2" v-for="(item, index) in data.all_filter" :key="index" v-if="item.isActiveFilter == '1'">
                    <div class="d-flex justify-content-center align-items-center" @click="getFilterVal(data, item, index2, index, '1')">
                      <div>{{ item.title }}</div>
                      <div class="filter-close">x</div>
                    </div>
                  </li>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </section>
  

    <!-- HOME MAIN SLIDER -->
    <!-- <section class="bg-light py-1 d-none d-md-block">
      <div class="container-fluid px-0 my-4">

        <Slick ref="slickBanner" :options="homeSlider">

          <div v-if="Banners.length == 0" v-for="(singleBanner, bannerKey1) in 3" :key="bannerKey1">
            <div class="slider-container mx-auto">
              <img src="@/assets/img/transparent_banner.png" alt class="img-fluid cus-img" />
            </div>
          </div>

          <div v-if="Banners.length > 0" v-for="(singleBanner, bannerKey) in Banners" :key="bannerKey">
            <div class="slider-container mx-auto">
              <transition name="fade">
                <img v-if="singleBanner.banner_type_id == 1" v-lazy="singleBanner.banner_image_url" alt
                  class="img-fluid cus-img" />
              </transition>

              <div v-if="singleBanner.banner_type_id == 1" class="filterBox">
                <div class="filterBox">
                  <div class="d-flex justify-content-between align-items-center w-100 pl-4 pl-xl-5 detailBox">
                    <div class="movieDetails text-white">
                      <p v-if="singleBanner.banner_type_id == 1" class="mTitle">
                        {{ singleBanner.banner_name }}
                      </p>
                      <ul v-if="singleBanner.banner_type_id == 1" class="list-inline mInfo">
                        <li class="list-inline-item">
                          {{ singleBanner.lang_name }}
                        </li>
                        <li class="list-inline-item">
                          {{ singleBanner.mrrdr_runtime }} min
                        </li>
                        <li class="list-inline-item">
                          {{ GetYear(singleBanner.mrrdr_release_date) }}
                        </li>
                        <li class="list-inline-item">
                          {{ singleBanner.rating }}
                        </li>
                      </ul>
                    </div>

                    <div v-if="singleBanner.banner_type_id == 1">
                      <div v-if="singleBanner.button_enabled == 'Y'">
                        <router-link :to="{
            name: 'createScreen',
            params: {
              movie_id: singleBanner.movie_id,
              content_lang_id: singleBanner.content_lang_id
            }
          }">
                          <img src="@/assets/img/svg/Create-your-own-Screening.svg" class="img-fluid ms-cs-img" />
                        </router-link>
                      </div>
                      <div v-else class="mr-4">
                        <router-link :to="{
            name: 'createScreen',
            params: {
              movie_id: singleBanner.movie_id,
              content_lang_id: singleBanner.content_lang_id
            }
          }">
                          <button class="btn btn-danger gogo-btn mr-4">
                            Book Now
                          </button>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slick>
      </div>
    </section> -->

    <!-- HOME NEW MAIN SLIDER -->
    <section class="bg-light py-1 d-none d-md-block">
  <div class="container-fluid py-0 px-0">
    <VueSlickCarousel
      ref="slickCarousel"
      v-bind="homeSliderNew"
      class="hide-on-small-devices"
      :style="{ paddingTop: '8px', paddingBottom: '3px' }"
    >
      <!-- Carousel content -->
      <div v-if="Banners.length == 0" v-for="(singleBanner, bannerKey1) in 3" :key="bannerKey1">
        <div class="slider-container mx-auto 22">
          <img src="@/assets/img/transparent_banner.png" alt class="img-fluid pt-2 cus-img object-fit-contain" />
        </div>
      </div>

      <div v-if="Banners.length > 0" v-for="(singleBanner, bannerKey) in Banners" :key="bannerKey">
        <div class="slider-container mx-auto 111">
          <transition name="fade image-border">
            <img v-lazy="singleBanner.banner_image_url" alt class="img-fluid cus-img banners object-fit-contain hloo" />
          </transition>
          <div class="filterBox">
            <div class="d-flex justify-content-between align-items-center w-100 pl-4 pl-xl-5 detailBox nidhi111">
              <div class="movieDetails text-white">
                <p v-if="singleBanner.banner_type_id == 1" class="mTitle">
                  {{ singleBanner.banner_name }}
                </p>
                <ul v-if="singleBanner.banner_type_id == 1" class="list-inline mInfo">
                  <li class="list-inline-item">
                    {{ singleBanner.lang_name }}
                  </li>
                  <li class="list-inline-item">
                    {{ singleBanner.mrrdr_runtime }} min
                  </li>
                  <li class="list-inline-item">
                    {{ GetYear(singleBanner.mrrdr_release_date) }}
                  </li>
                  <li class="list-inline-item">
                    {{ singleBanner.rating }}
                  </li>
                </ul>
              </div>
              <div v-if="singleBanner.banner_type_id == 1">
                <div v-if="singleBanner.button_enabled == 'Y'">
                  <router-link :to="{
                    name: 'createScreen',
                    params: {
                      movie_id: singleBanner.movie_id,
                      content_lang_id: singleBanner.content_lang_id
                    }
                  }">
                    <img src="@/assets/img/svg/Create-your-own-Screening.svg" class="img-fluid ms-cs-img" />
                  </router-link>
                </div>
                <div v-else class="mr-4">
                  <router-link :to="{
                    name: 'createScreen',
                    params: {
                      movie_id: singleBanner.movie_id,
                      content_lang_id: singleBanner.content_lang_id
                    }
                  }">
                    <div>
                      <button class="btn btn-danger gogo-btn mr-4">
                        Book Now
                      </button>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VueSlickCarousel>
  </div>
</section>


    <!-- <div>
    <div class="slider-container px-2">
      <img src="@/assets/img/Three-easy-steps-White-updated.png" alt class="img-fluid pt-2 cus-img object-fit-contain show-on-small-devices" />
    </div>
  </div> -->

    <!-- NOW SHOWING MOVIES SLIDER -->
    <section>
      <div class="container-fluid mb-4 mt-2 d-md-block d-none">
        <NowShowing />
      </div>
      <div class="container-fluid mb-4 d-md-none" :class="selectedTab.indexOf('1') >= 0 ? '' : 'd-none'">
        <NowShowingMobile />
      </div>
    </section>

    <!-- SPECIAL SCREENINGS MOVIES SLIDER -->
    <!-- <section class="bg-light py-2">
      <div class="container-fluid my-4">
        <SpecialScreenings />
      </div>
    </section>-->

    <!-- UPCOMING MINI FESTIVALS SLIDER -->
    <!-- <section class="d-md-block">
      <div class="container-fluid my-4 d-md-block d-none">
        <UpcomingFestivalsOne />
      </div>
      <div class="container-fluid mb-4 d-md-none" :class="selectedTab.indexOf('3') >= 0 ? '' : 'd-none'">
        <UpcomingFestivalsMobileOne />
      </div>
      <div></div> -->
      <!-- <div
        class="row d-md-none container-fluid"
        v-if="NextPage && loadingData == false"
      >
        <div class="col-12 text-center">
          <img src="@/assets/img/loadMore.gif" class="load-more" />
        </div>
      </div> -->
    </section>



    <!--  GOGO ON THE GOGO -->
    <section class="d-none">
      <div class="container-fluid my-4 px-0">
        <div class="gogo-container">
          <img src="@/assets/img/svg/GogoOnGobg.svg" class="img-fluid w-100" />

          <div class="gogo-platform">
            <div class="col-6">
              <p class="title pb-2 pb-md-4">GoGo on the GO!</p>
              <p class="txt pb-4 pb-md-5">
                Download the App and book tickets to your favorite films
                whenever, where ever!
              </p>
              <div>
                <router-link to>
                  <img src="@/assets/img/svg/GooglePlay-icon.svg" class="img-fluid" />
                </router-link>
                <router-link to class="bg-white py-2">
                  <img src="@/assets/img/svg/AppStore-icon.svg" class="img-fluid" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>



    <!-- UPCOMING MINI FESTIVALS SLIDER -->
    <section class="d-md-block">
      <div class="container-fluid my-4 d-md-block d-none">
        <UpcomingFestivals />
      </div>
      <div class="container-fluid mb-4 d-md-none" :class="selectedTab.indexOf('3') >= 0 ? '' : 'd-none'">
        <UpcomingFestivalsMobile />
      </div>
      <div></div>
      <!-- <div
        class="row d-md-none container-fluid"
        v-if="NextPage && loadingData == false"
      >
        <div class="col-12 text-center">
          <img src="@/assets/img/loadMore.gif" class="load-more" />
        </div>
      </div> -->
    </section>




    <!--  GOGO OFFERS -->
    <!-- <section>
      <div class="container-fluid my-4">
        <div class="row">
          <div class="col-12 col-md-6 mb-4 mb-md-0 mx-auto text-center">
            <img src="@/assets/img/Offer1.png" class="img-fluid rounded" />
          </div>

          <div class="col-12 col-md-6 mx-auto text-center">
            <img src="@/assets/img/Offer2.png" class="img-fluid rounded" />
          </div>
        </div>
      </div>
    </section>-->

    <!-- <section class="container-fluid menu-bottom-fix d-md-none">
      <BOTTOMBAR />
    </section>-->

    <div class="d-md-none" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="0">
    </div>

    <!--FILTER MODAL -->
    <b-modal hide-header-close hide-footer ref="filterModalRef" id="filterModal" title="Choose Any Filter"
      modal-class="welcome-b">
      <button type="button" @click="hideFilter()" aria-label="Close" class="close">
        ×
      </button>
      <div class="col-12 loginmodal p-3 p-md-4">
        <div class="filter-tabs" v-for="(movie, index1) in showFilter" :key="index1">
          <p class="border-bottom pb-2">{{ movie.filter_name }}</p>
          <ul class="list-inline">
            <li class="list-inline-item" v-for="(data, index2) in movie.all_filter" :key="index2"
              @click="getFilterVal(movie, data, index1, index2, '2')" :class="data.isActive == '1' ? 'active' : ''"
              v-if="data.value">
              {{ data.title }}
            </li>
          </ul>
        </div>
        <div class="row proceed-btn-filter text-center mt-5 mx-auto">
          <div class="col-6 mx-0 mx-auto">
            <button type="button" name id class="btn" @click="resetFilter">
              Reset
            </button>
          </div>
          <div class="col-6 mx-0 mx-auto">
            <button type="button" name id class="btn apply-filter" @click="applyFilter">
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </b-modal>


    <!-- CREATE YOUR OWN SCREENING SLIDER -->
    <section class="bg-light ownScreen-color py-2 d-md-block d-none">
      <div class="container-fluid mb-4">
        <OwnScreening />
      </div>
    </section>
    <section class="py-2 d-md-none">
      <div class="container-fluid mb-4 d-md-none" :class="selectedTab.indexOf('2') >= 0 ? '' : 'd-none'">
        <OwnScreeningMobile />
      </div>
    </section>

  </div>
</template>

<script>
import Slick from "vue-slick";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
// import { dragscroll } from 'vue-dragscroll'
import { URL_BASE, LIMIT } from "@/helper/constants";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";

import NowShowing from "@/components/partials/nowShowingSlider.vue";
import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";

import NowShowingMobile from "@/components/partials/nowShowingSliderMobile.vue";
import SpecialScreeningsMobile from "@/components/partials/SpecialScreeningsSliderMobile.vue";
import OwnScreeningMobile from "@/components/partials/OwnScreeningSliderMobile.vue";

import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";
import UpcomingFestivalsOne from "@/components/partials/UpcomingMiniFestivalsone.vue";

import UpcomingFestivalsMobile from "@/components/partials/UpcomingMiniFestivalsMobile.vue";
import UpcomingFestivalsMobileOne from "@/components/partials/UpcomingMiniFestivalsMobileOne.vue";

import BOTTOMBAR from "@/components/partials/BottomBar.vue";
import loader from "@/components/partials/loader.vue";
import EventBus from "@/eventBus.js";
import { TokenService, CountryService } from "@/services/storage.service";
import MainServices from "@/services/mainService.js";
import moment from "moment";

import VueSlickCarousel from 'vue-slick-carousel'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  name: "home",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    VueSlickCarousel,
    NowShowing,
    loader,
    SpecialScreenings,
    NowShowingMobile,
    SpecialScreeningsMobile,
    OwnScreeningMobile,
    OwnScreening,
    UpcomingFestivals,
    UpcomingFestivalsMobile,
    UpcomingFestivalsOne,
    UpcomingFestivalsMobileOne,
    Slick,
    BOTTOMBAR,
    DatePick
  },

  computed: {
    checkFilterExist() {
      let obj = false;
      this.showFilter.map(x => {
        x.all_filter.map(y => {
          if (y.isActiveFilter == "1") {
            obj = true;
          }
        });
      });
      return obj;
    }
  },
  data() {
    return {
      tabArray: [
        {
          // title: "Now Showing",
          title: "Join This Show",
          position: "1",
          active: "1",
          payload: { CategoryID: 1 }
        },
        {
          title: "Create Your \n Own Show",
          position: "2",
          active: "0",
          payload: {
            CategoryID: 4
          }
        },
        {
          title: "Gogo Library",
          position: "3",
          active: "0",
          payload: {
            CategoryID: 3
          }
        }
      ],

      movieFilterArray: [
        "English",
        "Citimall",
        "Mumbai",
        "2D",
        "English",
        "Citimall",
        "Mumbai",
        "2D"
      ],
      homeSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "15%",
        slidesToScroll: 1,
        // speed: 1000,

        responsive: [
          {
            breakpoint: 1025,
            settings: {
              arrows: true,
              dots: true,
              centerMode: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },

      homeSliderNew: {
        centerMode: true,
        centerPadding: "15%",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        lazyLoad: "progressive",
        // speed: 1000,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              arrows: true,
              // dots: true,
              centerMode: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      mobileHomeSliderNew:{
        centerMode: true,
        // centerPadding: "15%",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        lazyLoad: "progressive",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false, 
              centerMode: true,
              // centerPadding: "10%", 
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },



      loaded: false,
      NowShowing: [],
      Banners: [],
      selectedTab: ["5"],
      showFilter: [],
      filterObj: {},
      selectedBottomTab: ["1"],
      // NEW
      MobileData: {
        nowShowing: [],
        OwnScreeningData: [],
        MiniFestivalData: []
      },
      busy: false,
      arrayCheck: ["Ajit"],
      count: 0,
      PageNo: 0,
      lastPage: 1,
      loadingData: true,
      NextPage: false,
      MiniFestivals: []
    };
  },
  beforeDestroy() {
    EventBus.$emit("FOOTERSET", false);
    EventBus.$emit("CHECKROUTE", false);
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeMount() {
    this.getBannerData();
    this.fetchFilterDetails();
    if (screen.width > 768) {
      this.getNowShowingData();
    }

    let payload = {
      title: "Create Your \n Own Show",
      position: "2",
      active: "0",
      payload: {
        CategoryID: 4
      }
    };
    // this.TabChange("2",payload);
    this.TabChange("3", payload);
    // this.getFestivals();
    // this.getCreateYourScreeningData();
    // this.getUpcomingShow();
    // this.getQuickBookDetails();
    // this.getLanguages();
  },
  mounted() {
    EventBus.$emit("CHECKROUTE", true);
    EventBus.$emit("FOOTERSET", true);
    EventBus.$emit("BOTTOMTABCHANGE", "1");
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    getFestivals() {
      MainServices.GetMiniFestivals().then(response => {
        const { data } = response;
        console.log("response", response);



        data.Records.sort((a, b) => {
          const aDescription = a.category_link_description.toLowerCase();
          const bDescription = b.category_link_description.toLowerCase();

          // Handle the special case where "New Movies" should be at the top
          if (aDescription === 'new movies') return -1;
          if (bDescription === 'new movies') return 1;

          // Alphabetical sort for the rest of the items
          if (aDescription < bDescription) return -1;
          if (aDescription > bDescription) return 1;
          return 0;
        });

        console.log(data.Records, "data.Records >>>>>>>>>>>>>>>>>>")

        if (data.status) {
          this.MiniFestivals = data.Records;
          this.MobileData.MiniFestivalData = data.Records;
          EventBus.$emit("MINI", data.Records);
          this.loadingData = true;
        }
      });
    },
    GetYear(date) {
      return moment(date).format("YYYY");
    },
    loadMore: function () {
      console.log(this.loadingData, this.NextPage);
      if (this.loadingData && this.NextPage) {
        this.loadingData = false;
        setTimeout(() => {
          let count = this.selectedTab[0] - 1;
          console.log(this.selectedTab, "fdsdfsd");
          this.getPaginationData(
            this.tabArray[count]["payload"],
            this.selectedTab[0]
          );
        }, 1000);
      }
    },
    bottomTab(val) {
      // this.selectedBottomTab=[];
      // this.selectedBottomTab.push(val)
      if (val == "2") {
        this.$router.push({
          path: "/offers-promotions"
        });
      } else if (val == "3") {
        let token = TokenService.getToken();
        if (token == null || token == "" || token == undefined) {
          EventBus.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myTransaction"
          });
        }
      } else if (val == "4") {
        let token = TokenService.getToken();
        if (token == null || token == "" || token == undefined) {
          EventBus.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myaccount"
          });
        }
      }
    },
    getPaginationData: function (payload, value) {
      if (this.showFilter.length > 0) {
        this.showFilter.map(x => {
          if (this.filterObj[x.filter_key].length > 0) {
            payload[x.query_id] = this.filterObj[x.filter_key].toString();
          } else {
            delete payload[x.query_id];
          }
        });
      }
      // console.log(payload);
      payload["PageNo"] = this.PageNo;
      payload["Version"] = "1";
      console.log(value, "fsddfsdfsdfsd");
      if (value == 1) {
        this.getNowShowingData(payload);
      } else if (value == 2) {
        this.getCreateYourScreeningData(payload);
      }

      // makeRequest("/GetShows/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       this.PageNo = res.data.Shows.PageNo;
      //       this.NextPage = res.data.Shows.Next;

      //       if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 1
      //       ) {
      //         res.data.Shows.Movies.map(x => {
      //           let __Index = this.MobileData.NowShowing.findIndex(
      //             z => z.ID === x.ID
      //           );
      //           if (__Index === -1) {
      //             this.MobileData.NowShowing.push(x);
      //           }
      //         });
      //         EventBus.$emit("NOWSHOWING", this.MobileData.NowShowing);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 4
      //       ) {
      //         res.data.Shows.Movies.map(x => {
      //           let __Index = this.MobileData.OwnScreeningData.findIndex(
      //             z => z.ID === x.ID
      //           );
      //           if (__Index === -1) {
      //             this.MobileData.OwnScreeningData.push(x);
      //           }
      //         });
      //         EventBus.$emit("CREATESHOWING", this.MobileData.OwnScreeningData);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 3
      //       ) {
      //         res.data.Shows.Movies.map(x => {
      //           let __Index = this.MobileData.MiniFestivalData.findIndex(
      //             z => z.ID === x.ID
      //           );
      //           if (__Index === -1) {
      //             this.MobileData.MiniFestivalData.push(x);
      //           }
      //         });
      //         EventBus.$emit("MINI", this.MobileData.MiniFestivalData);
      //       }
      //       this.loadingData = true;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    getCreateYourScreeningData() {
      let payloadNew = { limit: LIMIT, currentPage: this.PageNo };
      if (this.showFilter.length > 0) {
        this.showFilter.map(x => {
          if (this.filterObj[x.filter_key].length > 0) {
            payloadNew[x.query_id] = this.filterObj[x.filter_key].toString();
          } else {
            delete payloadNew[x.query_id];
          }
        });
      }
      MainServices.GetCreateOwnShow(payloadNew)
        .then(response => {
          const { data } = response;
          console.log("response", response, this.PageNo);
          if (data.status && data.Records.data.length > 0) {
            if (this.PageNo > 1) {
              this.MobileData.OwnScreeningData = [
                ...this.MobileData.OwnScreeningData,
                ...data.Records.data
              ];
            } else {
              console.log("TESSSSSSST", this.PageNo)
              this.lastPage = data.Records.pagination.lastPage;
              this.MobileData.OwnScreeningData = data.Records.data;
            }

            console.log(data, "fsdfsdf");
            EventBus.$emit("CREATESHOWING", this.MobileData.OwnScreeningData);
            this.PageNo = this.PageNo + 1;

            this.NextPage = this.lastPage >= this.PageNo;
            this.loadingData = true;

            // this.$refs.slick1.destroy();
            // this.$nextTick(() => {
            //   this.$refs.slick1.create();
            //   this.$refs.slick1.goTo(1, true);
            // });
          } else if (this.PageNo == 1) {
            this.MobileData.OwnScreeningData = [];
            EventBus.$emit("CREATESHOWING", this.MobileData.OwnScreeningData);
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },

    getNowShowingData: function (payload) {
      let payloadNew = { limit: LIMIT, currentPage: this.PageNo };
      if (this.showFilter.length > 0) {
        this.showFilter.map(x => {
          if (this.filterObj[x.filter_key].length > 0) {
            payloadNew[x.query_id] = this.filterObj[x.filter_key].toString();
          } else {
            delete payloadNew[x.query_id];
          }
        });
      }
      MainServices.GetTodaysScreening(payloadNew)
        .then(response => {
          const { data } = response;
          this.loadingData = true;
          console.log("response", response);
          if (data.status && data.Records.data.length > 0) {
            if (this.PageNo > 1) {
              this.MobileData.NowShowing = [
                ...this.MobileData.NowShowing,
                ...data.Records.data
              ];
            } else {
              this.lastPage = data.Records.pagination.lastPage;
              this.MobileData.NowShowing = data.Records.data;
            }

            EventBus.$emit("NOWSHOWING", this.MobileData.NowShowing);

            this.PageNo = this.PageNo + 1;
            this.NextPage = this.lastPage >= this.PageNo;
            // this.$refs.slick1.destroy();
            // this.$nextTick(() => {
            //   this.$refs.slick1.create();
            //   this.$refs.slick1.goTo(1, true);
            // });
          } else if (this.PageNo == 1) {
            this.MobileData.NowShowing = [];

            EventBus.$emit("NOWSHOWING", this.MobileData.NowShowing);

          }
        })
        .catch(error => {
          console.log("Error", error);
        });
      // makeRequest("/GetShows/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       //        tabArray: [
      //       //   {
      //       //     title: "Now Showing",
      //       //     position: "1",
      //       //     active: "1",
      //       //     payload: { CategoryID: 1 }
      //       //   },
      //       //   {
      //       //     title: "Create Your \n Own Show",
      //       //     position: "2",
      //       //     active: "0",
      //       //     payload: {
      //       //       CategoryID: 4
      //       //     }
      //       //   },
      //       //   {
      //       //     title: "Animation Special",
      //       //     position: "3",
      //       //     active: "0",
      //       //     payload: {
      //       //       CategoryID: 3
      //       //     }
      //       //   }
      //       // ],
      //       if (this.tabArray.length == 0) {
      //         res.data.Categories.map((x, index) => {
      //           let obj = {
      //             title: x.CategoryName,
      //             active: index == 0 ? "1" : "0",
      //             position: `${index + 1}`,
      //             payload: { CategoryID: x.CategoryID }
      //           };
      //           this.tabArray.push(obj);
      //         });
      //         console.log(this.tabArray);
      //       }
      //       console.log("fsdfsdf");
      //       this.PageNo = res.data.Shows.PageNo;
      //       this.NextPage = res.data.Shows.Next;
      //       if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 1
      //       ) {
      //         this.MobileData.NowShowing = res.data.Shows.Movies;
      //         EventBus.$emit("NOWSHOWING", this.MobileData.NowShowing);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 4
      //       ) {
      //         this.MobileData.OwnScreeningData = res.data.Shows.Movies;
      //         EventBus.$emit("CREATESHOWING", this.MobileData.OwnScreeningData);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 3
      //       ) {
      //         this.MobileData.MiniFestivalData = res.data.Shows.Movies;
      //         EventBus.$emit("MINI", this.MobileData.MiniFestivalData);
      //       }
      //       window.scroll(0, 0);
      //       this.$refs["filterModalRef"].hide();
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    redirectApi() {
      this.PageNo = 1;
      if (this.selectedTab == 1) {
        this.getNowShowingData({});
      } else if (this.selectedTab == 2) {
        this.getCreateYourScreeningData({});
      } else if (this.selectedTab == 3) {
        this.getFestivals({});
      }
    },

    resetFilter: function () {
      this.PageNo = 1;
      this.showFilter.map(x => {
        this[x.filter_key] = [];
      });
      this.redirectApi();

      this.showFilter = [];

      this.hideFilter();
    },
    getFilterVal(movie, data, index1, index2, val) {
      let i = this.filterObj[movie.filter_key].indexOf(data.value);
      this.filterObj[movie.filter_key] = [];
      this.showFilter[index1].all_filter.map(y => {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });
      if (i >= 0) {
        if (val == "1") {
          this.redirectApi();
        }
        return false;
      }
      setTimeout(x => {
        if (i >= 0) {
          this.filterObj[movie.filter_key].splice(i, 1);
          this.showFilter[index1].all_filter[index2].isActive = "0";
          if (val == "1") {
            this.showFilter[index1].all_filter[index2].isActiveFilter = "0";
          }
        } else {
          this.filterObj[movie.filter_key].push(data.value);
          this.showFilter[index1].all_filter[index2].isActive = "1";
        }
        if (val == "1") {
          // this.fetchScreeningDetails();
        }
      }, 100);
    },
    // getFilterVal(movie, data, index1, index2, val) {
    //   let i = this.filterObj[movie.filter_key].indexOf(data.value);
    //   if (i >= 0) {
    //     this.filterObj[movie.filter_key].splice(i, 1);
    //     this.showFilter[index1].all_filter[index2].isActive = "0";
    //     if (val == "1") {
    //       this.showFilter[index1].all_filter[index2].isActiveFilter = "0";
    //     }
    //   } else {
    //     this.filterObj[movie.filter_key].push(data.value);
    //     this.showFilter[index1].all_filter[index2].isActive = "1";
    //   }
    //   if (val == "1") {
    //     let count = this.selectedTab[0] - 1;
    //     this.getNowShowingData(this.tabArray[count]["payload"]);
    //   }
    // },
    applyFilter() {
      this.PageNo = 1;
      this.showFilter.map(x => {
        x.all_filter.map(y => {
          if (y.isActive == "1") {
            y.isActiveFilter = "1";
          }
        });
      });
      console.log(this.selectedTab);
      this.redirectApi();
      this.hideFilter();
    },
    showFilterModal() {
      this.$refs["filterModalRef"].show();
    },
    hideFilter() {
      this.$refs["filterModalRef"].hide();
    },
    fetchFilterDetails: function () {
      let payload = {};
      MainServices.GetFilterList()
        .then(response => {
          const { data } = response;

          if (data.filterData.length > 0) {
            data.filterData.map(x => {
              this.filterObj[x.filter_key] = [];
              x.all_filter.map(y => {
                y["isActive"] = "0";
                y["isActiveFilter"] = "0";
              });
            });
            this.showFilter = data.filterData;
          }
        })

        .catch(error => {
          console.log("Error", error);
        });
    },
    TabChange(value, payload) {
      console.log(payload, "payloadpayloadpayloadpayload");
      let i = this.selectedTab.indexOf(value);
      if (i < 0) {
        this.PageNo = 1;
        this.NextPage = true;
        this.lastPage = 1;
        this.selectedTab = [];
        this.selectedTab.push(value);
        window.scroll(0, 0);
        this.movieFilterArray = [];
        EventBus.$emit("LoadingMini", true);
        EventBus.$emit("LoadingNow", true);
        EventBus.$emit("LoadingShow", true);
        if (value == 1) {
          this.getNowShowingData(payload);
        } else if (value == 2) {
          this.getCreateYourScreeningData(payload);
        } else if (value == 3) {
          this.getFestivals();
        }
      }
    },
    getBannerData: function () {
      this.showLoading();
      MainServices.GetBanners()
        .then(response => {
          const { data } = response;
          // console.log("esponse222", response);
          console.log(data.Records, "data.Records>>")

          this.hideLoading();
          if (data.status) {
            const records = data.Records.map((res) => {
              console.log(res, "res>>>")
              if (res['b_id'] == 205) {
                delete res.b_order


                res['banner_image_url'] = "https://api-test-1.binarynumbers.io/uploads/fnb_item/whats-app-image.jpg"
              }
            })


            this.Banners = data.Records.sort((a, b) => {
              return a.b_id - b.b_id
            })

            console.log(this.Banners, "this.Banners >>>>>>>>>>>>>.")

            // let a = data.Records;
            // a = a.concat([...a]);
            // a = a.concat([...a]);
            // a = a.concat([...a]);
            // a = a.concat([...a]);
            // this.Banners = a;
            // console.log(a, "Rec")

            this.loaded = true;
            this.$refs.slickBanner.destroy();
            this.$nextTick(() => {
              this.$refs.slickBanner.create();
              this.$refs.slickBanner.goTo(0, true);
            });
          }
        })
        .catch(err => {
          console.log("Error", err);
        });
      // makeRequest("/cinema/banners", "GET", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.hideLoading();
      //     if (res.data.Status) {
      //       this.Banners = res.data.Banner;
      //       this.loaded = true;
      //       this.Banners.filter(movie => {
      //         return movie.hasOwnProperty("MovieDetails");
      //       }).map(x => {
      //         this.Banners.Actor =
      //           this.Banners.Actors && this.Banners.Actors[0].Name;
      //         this.Banners.RYear = x.MovieDetails.Year.split(" ")[2];
      //       });
      //       this.$refs.slickBanner.destroy();
      //       this.$nextTick(() => {
      //         this.$refs.slickBanner.create();
      //         this.$refs.slickBanner.goTo(1, true);
      //       });
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    handleScroll: function() {
      const imageHeight = document.querySelector('.slider-container').offsetHeight;
      this.isSticky = window.scrollY > imageHeight;
    },
  }
};
</script>

<style scoped>
.red-line {
  background: linear-gradient(179.82deg, #e70d00 17.86%, #fa5402 126.35%);
}

.back-txt a {
  font-size: 14px;
  color: #8d99af;
  font-weight: bold;
}

/* CALENDER */
.calendar .weekdays .day-grid {
  /* display: flex;
  justify-content: center;
  align-items: center; */
  height: 40px;
  width: 40px;
  font-size: 14px;
  color: #212b36;
}

.fade-enter-active {
  transition: opacity 3s ease-in-out;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

/* .mInfo li:last-child:::after{
  counter-reset: ;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/home.vue